import script from "./SiteOffline.vue?vue&type=script&setup=true&lang=js"
export * from "./SiteOffline.vue?vue&type=script&setup=true&lang=js"

import "./SiteOffline.vue?vue&type=style&index=0&id=05e26cf7&scoped=true&lang=css"

import exportComponent from "C:\\xampp8\\htdocs\\edb_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05e26cf7"]])

export default __exports__